import React, {useState} from 'react';
import styles from "../RecoveryPasswordRequest.module.css";
import Input from "../../../../components/Utils/Inputs/Input/Input";
import Buttons, {
    EnumButtonType,
    EnumButtonWeight,
    EnumColors
} from "../../../../components/Utils/Buttons/Buttons/Buttons";
import {authApi} from "../../../../api/authApi";
import {toast} from "react-toastify";

interface IProps {
    setIsSent: (status: boolean) => void
}

const RecoveryPasswordRequestForm = ({setIsSent}: IProps) => {


    const [email, setEmail] = useState<string>('')
    const [isFetching, setIsFetching] = useState<boolean>(false)

    const sendRecoveryRequestHandler = async () => {
        setIsFetching(true)
        try {
            await authApi.sendRecoveryRequest(email)
            toast.success('Письмо было отправлено!')
            setIsFetching(false)
            setIsSent(true)
        } catch (error) {
            console.log(error)
            // @ts-ignore
            toast.error(error.response.data.message)
            setIsFetching(false)
        }
    }


    return (
        <>
            <p>Вы можете запросить новое письмо на Вашу почту с ссылкой на восстановление пароля</p>
            <div className={styles.wrapper}>
                <Input
                    type={'email'}
                    onChange={(e) => setEmail(String(e.target.value))}
                    className={styles.input}
                    placeholder={'Введите email'}/>
                <Buttons
                    weight={EnumButtonWeight.slim}
                    color={EnumColors.gold}
                    type={EnumButtonType.filled}
                    onClick={sendRecoveryRequestHandler}
                    loading={isFetching}
                    disabled={isFetching}
                    className={styles.button}
                >Восстановить</Buttons>
            </div>
        </>
    );
};

export default RecoveryPasswordRequestForm;